import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find-index.js";
import { computed, defineComponent, nextTick, onMounted, reactive, ref, watch } from "vue";
import { useStore } from "vuex";
import { useAudio, usePlayerState } from "@/hooks/player/hookPlayer";
import { formatArtistListToString, transformSecondToMinute } from "@/utils/player/format";
import MPIcon from "@/baseui/player/MPIcon.vue";
import VolumeAdjuster from "@/baseui/player/volume.vue";
import { playerNextReOrder } from "@/utils/player/algorithm";
import { gotoArtistDetail } from "@/utils/player/routerPush";
import PlaybackAdjuster from "@/baseui/player/playerBack.vue";
export default defineComponent({
  components: {
    "mp-icon": MPIcon,
    "volume-adjuster": VolumeAdjuster,
    PlaybackAdjuster: PlaybackAdjuster
  },
  name: "MusicPlayer",
  setup: function setup() {
    var store = useStore();

    var _usePlayerState = usePlayerState(),
        playerState = _usePlayerState.playerState,
        toggleExpandSong = _usePlayerState.toggleExpandSong;
    /** 播放器元素 */


    var audioPlayerRef = ref();
    /** 当前播放的歌曲id */

    var currentPlayId = ref(-1);
    /** 当前歌曲播放状态 */

    var songState = reactive({
      isAdjusting: false
    });
    /** 播放器是否暂停 */

    var isPause = computed(function () {
      return store.state.player.isPause;
    });
    /** 播放器音量 */

    var currentVolume = computed(function () {
      return store.state.player.volume;
    });
    /** 当前歌曲的时长 */

    var currentSongDuration = computed(function () {
      return store.state.player.currentDuration;
    });
    /** 当前歌曲的已播放的时长 */

    var currentSongPlayedDuration = computed(function () {
      return store.state.player.currentTime;
    });
    /** 当前歌曲的播放进度 */

    var currentPlayRate = computed(function () {
      return currentSongPlayedDuration.value / currentSongDuration.value;
    });
    /** 当前播放顺序 */

    var currentPlayBackType = computed(function () {
      return store.state.player.playBackType;
    });
    /** 歌曲列表 */

    var storeSongList = computed(function () {
      return store.state.player.songList;
    });
    /** 当前播放的歌曲 */

    var storeCurrentSong = computed(function () {
      return store.state.player.currentSong;
    });
    /** 是否展示歌曲详情 */

    var isShowSongDetail = computed(function () {
      return store.state.player.isShowSongDetail;
    });
    /** 当前播放的歌曲（没有歌曲播放的时候为undefined）*/

    var playingSong = computed(function () {
      if (currentPlayId.value !== -1) {
        return storeSongList.value.find(function (item) {
          return item.id === currentPlayId.value;
        });
      }

      return undefined;
    });
    /** 正在播放的歌曲的歌手名组成的数组 */

    var playingSongArtistStr = computed(function () {
      var artistStr = "";

      if (playingSong.value && playingSong.value.artists.length > 0) {
        artistStr = playingSong.value.artists.map(function (artist) {
          return artist.name;
        }).reduce(function (initValue, currentValue) {
          return initValue + "/" + currentValue;
        });
      }

      return artistStr;
    });
    /** 正在播放的歌曲的歌手列表 */

    var artists = computed(function () {
      if (playingSong.value) {
        return playingSong.value.artists;
      }

      return [];
    });
    /** 当前播放的歌曲的url */

    var currentSongUrl = computed(function () {
      if (playingSong.value) {
        return playingSong.value.songUrl;
      }

      return "";
    });
    watch(function () {
      return storeCurrentSong.value;
    }, function (nv, ov) {
      /** store中的当前歌曲存在，并且和上一次的歌曲不同则替换当前播放的歌曲id */
      if (nv !== undefined) {
        currentPlayId.value = nv.id;
        nextTick(function () {
          if (audioPlayerRef.value && !isPause.value) {
            audioPlayerRef.value.play();
          }
        });
      }
    }, {
      immediate: true
    });
    /** 更新是否暂停的状态 */

    var changeIsPause = function changeIsPause(isPause) {
      store.commit("player/setIsPause", isPause);
    };
    /** 切换播放顺序 */


    var changeCurrentPlayBackType = function changeCurrentPlayBackType(playBackType) {
      store.commit("player/setPlayBackType", playBackType);
    };
    /** 播放下一首音乐 */


    var playNext = function playNext() {
      /** 按照播放顺序，返回当前播放的歌曲 */
      var reOrderSong = playerNextReOrder(storeSongList.value, storeCurrentSong.value, currentPlayBackType.value.listState);

      if (!reOrderSong) {
        playPause();
      } else {
        currentPlayId.value = reOrderSong.id;
      }

      store.commit("player/setCurrentSong", reOrderSong);
    };
    /** 歌曲播放完毕后，自动播放下一曲 */


    var autoEndedPlayNext = function autoEndedPlayNext() {
      if (currentPlayBackType.value.listState === "icon-danquxunhuan") {
        if (audioPlayerRef.value) {
          audioPlayerRef.value.play();
        }
      } else {
        playNext();
      }
    };
    /** 播放上一首音乐 */


    var playPrev = function playPrev() {
      var findIndex = storeSongList.value.findIndex(function (song) {
        return song.id === currentPlayId.value;
      });
      /**
       * 当前无播放歌曲或者当前播放歌曲在列表中找不到，则播放列表的第一首歌曲
       */

      if (currentPlayId.value === -1 || findIndex === -1) {
        var _storeSongList$value$;

        currentPlayId.value = (_storeSongList$value$ = storeSongList.value[0]) === null || _storeSongList$value$ === void 0 ? void 0 : _storeSongList$value$.id;
        store.commit("player/setCurrentSong", storeSongList.value[0]);
        return;
      } else if (findIndex === 0) {
        /** 当前播放的是第一首，点击播放上一首歌曲则播放列表中的最后一首 */
        var length = storeSongList.value.length;
        currentPlayId.value = storeSongList.value[length - 1].id;
        store.commit("player/setCurrentSong", storeSongList.value[length - 1]);
        return;
      }

      var nextSong = storeSongList.value[findIndex - 1];
      currentPlayId.value = nextSong.id;
      store.commit("player/setCurrentSong", nextSong);
    };

    var playSongById = function playSongById(id) {
      var findIndex = storeSongList.value.findIndex(function (song) {
        return song.id === id;
      });
      /**
       * 当前无播放歌曲或者当前播放歌曲在列表中找不到，则播放下一首歌曲
       */

      if (id === -1 || findIndex === -1) {
        playNext();
      }

      var nextSong = storeSongList.value[findIndex];
      currentPlayId.value = nextSong.id;
      store.commit("player/setCurrentSong", nextSong);
    };
    /** 播放音乐 */


    var playSong = function playSong() {
      if (audioPlayerRef.value !== undefined) {
        changeIsPause(false);
        /** 如果当前歌曲已经播放，则设置当前播放时长 */

        if (currentSongPlayedDuration.value) {
          audioPlayerRef.value.currentTime = currentSongPlayedDuration.value;
        }

        audioPlayerRef.value.play();
      }
    };
    /** 暂停播放 */


    var playPause = function playPause() {
      if (audioPlayerRef.value !== undefined) {
        changeIsPause(true);
        audioPlayerRef.value.pause();
      }
    };
    /** 清空播放列表 */


    var clearPlayList = function clearPlayList() {
      changeIsPause(true);
      store.commit("player/setCurrentSong", undefined);
      store.commit("player/setSongList", []);
    };
    /** 调整音量 */


    var onChangeVolume = function onChangeVolume(volume) {
      if (audioPlayerRef.value) {
        store.commit("player/setVolume", volume);
        audioPlayerRef.value.volume = volume;
      }
    };
    /** 展示歌曲详情 */


    var displaySongDetail = function displaySongDetail(id) {
      if (id) {
        store.commit("player/setIsShowSongDetail", !isShowSongDetail.value);
      }
    };
    /** 控制是否在拖拽进度 */


    var handleIsDragingChange = function handleIsDragingChange(isDraging) {
      songState.isAdjusting = isDraging;

      if (audioPlayerRef.value) {
        audioPlayerRef.value.currentTime = currentSongPlayedDuration.value;
      }
    };
    /** 控制播放进度 */


    var handlePlayRateChange = function handlePlayRateChange(innerPercentage, percentage) {
      if (percentage !== undefined) {
        songState.isAdjusting = false;
        store.commit("player/setCurrentTime", currentSongDuration.value * percentage);

        if (audioPlayerRef.value) {
          audioPlayerRef.value.currentTime = currentSongPlayedDuration.value;
        }
      } else {
        songState.isAdjusting = true;
        store.commit("player/setCurrentTime", currentSongDuration.value * innerPercentage);
      }
    };

    onMounted(function () {
      if (audioPlayerRef.value !== undefined) {
        audioPlayerRef.value.volume = currentVolume.value;
        changeIsPause(true);

        var _useAudio = useAudio(audioPlayerRef, songState, playNext, autoEndedPlayNext),
            initAudio = _useAudio.initAudio;

        initAudio();
      }

      var songListEle = document.querySelector("#music-song-list");
      document.addEventListener("click", function (e) {
        /** 被点击的元素不是songListEle，就隐藏songListEle */
        if (e.target !== songListEle && playerState.expandSong) {
          toggleExpandSong(false);
        }
      });
    });
    return {
      audioPlayerRef: audioPlayerRef,
      playingSong: playingSong,
      playingSongArtistStr: playingSongArtistStr,
      artists: artists,
      currentSongUrl: currentSongUrl,
      playerState: playerState,
      isPause: isPause,
      currentVolume: currentVolume,
      currentSongDuration: currentSongDuration,
      currentSongPlayedDuration: currentSongPlayedDuration,
      currentPlayRate: currentPlayRate,
      currentPlayBackType: currentPlayBackType,
      storeSongList: storeSongList,
      changeCurrentPlayBackType: changeCurrentPlayBackType,
      toggleExpandSong: toggleExpandSong,
      gotoArtistDetail: gotoArtistDetail,
      playNext: playNext,
      playPrev: playPrev,
      playSong: playSong,
      playPause: playPause,
      transformSecondToMinute: transformSecondToMinute,
      formatArtistListToString: formatArtistListToString,
      playSongById: playSongById,
      clearPlayList: clearPlayList,
      onChangeVolume: onChangeVolume,
      displaySongDetail: displaySongDetail,
      handleIsDragingChange: handleIsDragingChange,
      handlePlayRateChange: handlePlayRateChange
    };
  }
});